export const REGEX_EMAIL = /^(([^<>()\[\]\\.,;:\s@\"\x80-\uFFFF]+(\.[^<>()\[\]\\.,;:\s@\"\x80-\uFFFF]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,}))$/;
export const REGEX_PHONE = /([+]?)\d{9,14}/;
export const REGEX_DOC_NUM = /\s/;
